import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import { find } from "lodash";
import { Typography } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { audioVideoSliceActions } from "../../../../Store/Slices/AudioVideoSlice";

let audios = null;

const WwChat = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [firstPerson, setFirstPerson] = useState(null);

  useEffect(() => {
    console.log("&&&&&&HHHHHH", props.data);
    if (props.data?.items) {
      setFirstPerson(props.data?.items[0].person.trim());
    }
    return () => {
      if (audios) {
        audios.pause();
        dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      }

      document.getElementById("text").style.display = "block";
      document.getElementById("alttext").style.display = "none";
    };
  }, [props.data]);

  const getImage = (person) => {
    if (props.data) {
      let foundObj = find(props.data.members, { name: person });
      if (foundObj) {
        return foundObj.image;
      }
      return "/static/images/avatar/1.jpg";
    }
  };

  const wordClick = (context) => {
    if (context?.media?.audio) {
      if (audios && !audios.paused) {
        return false;
      }
      audios = new Audio(
        `${sessionStorage.getItem('media_url')}audio/${context?.media?.audio}`
      );
      audios.onended = () => {
        dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      };
      if (audios && audios.paused) {
        audios.play();
        dispatch(audioVideoSliceActions.setAudioIsPlaying(true));
        dispatch(audioVideoSliceActions.setCurrentAudioSrc(null));
      } else {
        audios.pause();
        dispatch(audioVideoSliceActions.setAudioIsPlaying(false));
      }
    }
  };

  return (
    <>
      {props.data && props.data.items && (
        <Grid container>
          <Grid xs={12}>
            <List sx={{}} id="text" style={{ display: "block" }}>
              {props.data.items.map((val, index) => {
                return (
                  <>
                    {firstPerson && firstPerson == val.person.trim() && (
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar
                            alt="Remy Sharp"
                            src={`${
                              sessionStorage.getItem('media_url')
                            }image/${getImage(val.person)}`}
                            sx={{
                              border: "3px solid #DB8829",
                              borderStyle: "double",
                              backgroundColor: "#F5F7FF",
                              padding: "0.1rem",
                              "@media (min-width: 1636px)": {
                                width: 60,
                                height: 60,
                              },
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          disableTypography={true}
                          sx={{
                            width: "50%",
                            fontSize: "1.2rem",
                            fontWeight: 500,
                            position: "relative",
                            color: "primary.main",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.8rem",
                              pl: 2,
                            },
                          }}
                        >
                          <p
                            style={{
                              backgroundColor: "#e5ecff",
                              padding: "10px",
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 40,
                              borderBottomLeftRadius: 40,
                              borderBottomRightRadius: 40,
                              width: "fit-content",
                              maxWidth: "80%",
                              margin: "0px",
                              wordWrap: "break-word",
                            }}
                          >
                            {val.text && <span>{val.text}</span>}
                            {val.richtext &&
                              val.richtext.map((spanword, richind) => {
                                return (
                                  <>
                                    {spanword?.beautify == "none" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        {spanword.word}
                                      </span>
                                    )}
                                    {spanword?.beautify == "bold" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        <b style={{fontWeight: '900'}}>{spanword.word}</b>
                                      </span>
                                    )}
                                    {spanword?.beautify == "underline" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        <u>{spanword.word}</u>
                                      </span>
                                    )}
                                    {spanword?.beautify == "italic" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        <i>{spanword.word}</i>
                                      </span>
                                    )}
                                  </>
                                );
                              })}
                            <span className={classes.ChatPointerLeft}></span>
                          </p>
                        </ListItemText>
                      </ListItem>
                    )}
                    {firstPerson && firstPerson !== val.person.trim() && (
                      <ListItem>
                        <ListItemText
                          disableTypography={true}
                          sx={{
                            position: "relative",
                            textAlign: "-webkit-right",
                            pr: 1,
                            mr: 0.5,
                            fontSize: "1.2rem",
                            fontWeight: 500,
                            color: "primary.main",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.8rem",
                            },
                          }}
                        >
                          <p
                            style={{
                              backgroundColor: "#ffd89b",
                              padding: "10px",
                              backgroundColor: "#ffd89b",
                              padding: "10px",
                              borderTopLeftRadius: 40,
                              borderTopRightRadius: 0,
                              borderBottomLeftRadius: 40,
                              borderBottomRightRadius: 40,
                              width: "fit-content",
                              maxWidth: "80%",
                              margin: "0px",
                              wordWrap: "break-word",
                            }}
                          >
                            {val.text && <span>{val.text}</span>}
                            {val.richtext &&
                              val.richtext.map((spanword, richind) => {
                                return (
                                  <>
                                    {spanword?.beautify == "none" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        {spanword.word}
                                      </span>
                                    )}
                                    {spanword?.beautify == "bold" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        <b style={{fontWeight: '900'}}>{spanword.word}</b>
                                      </span>
                                    )}
                                    {spanword?.beautify == "underline" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        <u>{spanword.word}</u>
                                      </span>
                                    )}
                                    {spanword?.beautify == "italic" && (
                                      <span
                                        key={`${richind}_rich`}
                                        style={{ padding: "0 2px" }}
                                        onClick={() => {
                                          wordClick(spanword?.context);
                                        }}
                                      >
                                        <i>{spanword.word}</i>
                                      </span>
                                    )}
                                  </>
                                );
                              })}
                            <span className={classes.ChatPointerRight}></span>
                          </p>
                        </ListItemText>
                        <ListItemAvatar sx={{ textAlign: "right" }}>
                          <Avatar
                            alt="Remy Sharp"
                            src={`${
                              sessionStorage.getItem('media_url')
                            }image/${getImage(val.person)}`}
                            sx={{
                              border: "3px solid #ffa723",
                              borderStyle: "double",
                              backgroundColor: "#F5F7FF",
                              padding: "0.1rem",
                              "@media (min-width: 1636px)": {
                                width: 60,
                                height: 60,
                              },
                            }}
                          />
                        </ListItemAvatar>
                      </ListItem>
                    )}
                  </>
                );
              })}
            </List>
            <List sx={{}} id="alttext" style={{ display: "none" }}>
              {props.data.items.map((val, index) => {
                return (
                  <>
                    {firstPerson && firstPerson == val.person.trim() && (
                      <ListItem>
                        <ListItemAvatar>
                          <Avatar
                            alt="Remy Sharp"
                            src={`${
                              sessionStorage.getItem('media_url')
                            }image/${getImage(val.person)}`}
                            sx={{
                              border: "3px solid #DB8829",
                              borderStyle: "double",
                              backgroundColor: "#F5F7FF",
                              padding: "0.1rem",
                              "@media (min-width: 1636px)": {
                                width: 60,
                                height: 60,
                              },
                            }}
                          />
                        </ListItemAvatar>
                        <ListItemText
                          disableTypography={true}
                          sx={{
                            width: "50%",
                            fontSize: "1.2rem",
                            fontWeight: 600,
                            position: "relative",
                            color: "#EC3745",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.8rem",
                              pl: 2,
                            },
                          }}
                        >
                          <p
                            style={{
                              backgroundColor: "#e5ecff",
                              padding: "10px",
                              borderTopLeftRadius: 0,
                              borderTopRightRadius: 40,
                              borderBottomLeftRadius: 40,
                              borderBottomRightRadius: 40,
                              width: "fit-content",
                              maxWidth: "80%",
                              margin: "0px",
                            }}
                          >
                            <span>{val.alttext}</span>
                            <span className={classes.ChatPointerLeft}></span>
                          </p>
                        </ListItemText>
                      </ListItem>
                    )}
                    {firstPerson && firstPerson !== val.person.trim() && (
                      <ListItem>
                        <ListItemText
                          disableTypography={true}
                          sx={{
                            position: "relative",
                            textAlign: "-webkit-right",
                            pr: 1,
                            mr: 0.5,
                            fontSize: "1.2rem",
                            fontWeight: 600,
                            color: "primary.main",
                            "@media (min-width: 1636px)": {
                              fontSize: "1.8rem",
                            },
                          }}
                        >
                          <p
                            style={{
                              backgroundColor: "#ffd89b",
                              padding: "10px",
                              borderTopLeftRadius: 40,
                              borderTopRightRadius: 0,
                              borderBottomLeftRadius: 40,
                              borderBottomRightRadius: 40,
                              width: "fit-content",
                              maxWidth: "80%",
                              margin: "0px",
                            }}
                          >
                            <span>{val.alttext}</span>
                            <span className={classes.ChatPointerRight}></span>
                          </p>
                        </ListItemText>
                        <ListItemAvatar sx={{ textAlign: "right" }}>
                          <Avatar
                            alt="Remy Sharp"
                            src={`${
                              sessionStorage.getItem('media_url')
                            }image/${getImage(val.person)}`}
                            sx={{
                              border: "3px solid #ffa723",
                              borderStyle: "double",
                              backgroundColor: "#F5F7FF",
                              padding: "0.1rem",
                              "@media (min-width: 1636px)": {
                                width: 60,
                                height: 60,
                              },
                            }}
                          />
                        </ListItemAvatar>
                      </ListItem>
                    )}
                  </>
                );
              })}
            </List>
          </Grid>
        </Grid>
      )}
    </>
  );
};
const useStyles = makeStyles({
  ChatPointerLeft: {
    position: "absolute",
    width: 0,
    height: 0,
    left: "-8px",
    right: "auto",
    top: "0px",
    bottom: "auto",
    border: "20px solid",
    borderColor: "#e5ecff transparent transparent transparent",
    zIndex: "-1",
    "@media (min-width: 1636px)": {
      left: "4px",
    },
  },
  ChatPointerRight: {
    position: "absolute",
    width: 0,
    height: 0,
    left: "auto",
    right: "0px",
    top: "0px",
    bottom: "auto",
    border: "20px solid",
    borderColor: "#ffd89b transparent transparent transparent",
    zIndex: "-1",
    "@media (min-width: 1636px)": {
      right: "-4px",
      top: "-0px",
    },
  },
});
export default WwChat;
